module.exports = __webpack_public_path__ + "img/cassette-tape.de8ae126.svg";